import { io, type Socket } from 'socket.io-client';
import { api } from '../../lib/api';

// Même contrainte que le socket d'appels (voir features/calls/callsSignalingClient.ts) :
// le proxy Cloudflare ne relaie pas les upgrades WebSocket, donc on se connecte
// directement à l'origine Fly.io avec un ticket à usage unique plutôt que via /api.
const MESSAGES_WS_URL = import.meta.env.VITE_CALLS_WS_URL ?? 'http://localhost:3000';

export async function connectMessagesSocket(): Promise<Socket> {
  const { data } = await api.post<{ ticket: string }>('/messages/ticket');
  return io(`${MESSAGES_WS_URL}/messages`, {
    auth: { ticket: data.ticket },
    transports: ['websocket'],
  });
}
